const getOrderStatusColor = (order) => {
  if (order.isPaymentProblematic) return "#660000ff"

  if (order.isDispatched) return "#b6029b"

  const isOrderAddedByAccess =
    order.accountId !== order.addedByAccountId

  const inComplete =
    !order.isCod &&
    order.accountRole === "user" &&
    order.orderStatus === "pending" &&
    !isOrderAddedByAccess

  if (inComplete) return "#000000"

  if (order.orderStatus === "notConfirmed") return "#656565ff"

  if (order.orderStatus === "pending") return `var(--color-danger)`

  if (order.orderStatus === "paid") return `var(--color-info)`

  if (order.orderStatus === "canceled") return `var(--color-warning)`

  if (order.orderStatus === "delivered") return `var(--color-success)`
}

export default getOrderStatusColor